import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../api/api";
import Images from "../../../media/images";

const JobDetails = () => {
  const [jobOrder, setJobOrder] = useState([]);

  useEffect(() => {
    api
      .get("services/joborders/details/grouped-by-company/")
      .then((response) => {
        console.log(response.data);
        setJobOrder(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <div className="">
      <div className="text-primary-red font-Rakkas mt-2 text-center text-3xl font-bold lg:!mt-6">
        Your Job Details
      </div>
      <div className="">
        <img src={Images.title_border} alt="" className="mx-auto mt-4" />
      </div>
      <div className="flex justify-end px-5">
        <Link
        to="/services"
          className="bg-primary-blue font-Berkshire animation mt-5 rounded-xl px-5 py-3 text-white hover:bg-blue-900 lg:mt-0"
        >
          See All Services
        </Link>
      </div>
      {/* first company table */}
      {jobOrder.map((item, i) => {
        return (
          <div className="mt-3 w-full md:px-10">
            <div className="flex flex-col">
              <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <div className="bg-primary-blue font-Acme mb-2 flex justify-between gap-10 overflow-x-auto p-3 text-lg">
                      <div className="flex items-center gap-2">
                        <div className="col-span-1 font-bold text-white">
                          {i}
                        </div>
                        <div className="font-bold text-white">
                          {item.company_name}
                        </div>
                      </div>
                      <div className="font-bold text-white">
                        Redg. Date : {item.registration_date}
                      </div>
                      <div className="font-bold text-white">
                        Redg. No : {item.registration_number}
                      </div>
                      <div className="font-bold text-white">
                        PAN. No : {item.company_pan}
                      </div>
                    </div>
                    <table className="w-full text-center">
                      <thead className="font-Bree bg-primary-red border-b font-bold">
                        <tr>
                          <th
                            scope="col"
                            className="px-6 py-4 text-sm font-medium text-white"
                          >
                            SN.
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-4 text-sm font-medium text-white"
                          >
                            Service Name
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-4 text-sm font-medium text-white"
                          >
                            Order Date
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-4 text-sm font-medium text-white"
                          >
                            working Status
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-4 text-sm font-medium text-white"
                          >
                            Completed Date
                          </th>
                        </tr>
                      </thead>
                      <tbody className="font-Acme">

                        {
                          item.job_orders_details.map((detail, index) => {
                            return (
                              <tr className="font-Acme border-b bg-white" key={index}>
                              <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                                {index + 1}
                              </td>
                              <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                                {detail.company_name}
                              </td>
                              <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                                {/* 2078-9-10 */}
                                {detail.created_on}
                              </td>
                              <td className="bg-primary-green mt-1.5 inline-flex whitespace-nowrap rounded-full py-2 px-4 text-sm font-bold text-white">
                                Completed
                                {detail.status}
                               
                              </td>
                              <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                                {detail.completed_on}
                              </td>
                            </tr>
                            )
                          })
                        }
{/* 
                        <tr className="font-Acme border-b bg-white">
                          <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                            1
                          </td>
                          <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                            New Company Darta
                          </td>
                          <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                            2078-9-10
                          </td>
                          <td className="bg-primary-green mt-1.5 inline-flex whitespace-nowrap rounded-full py-2 px-4 text-sm font-bold text-white">
                            Completed
                          </td>
                          <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                            2078-9-10
                          </td>
                        </tr>
                        <tr className="border-b bg-white">
                          <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                            1
                          </td>
                          <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                            New Company Darta
                          </td>
                          <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                            2078-9-10
                          </td>
                          <td className="bg-primary-blue mt-1.5 inline-flex whitespace-nowrap rounded-full py-2 px-4 text-sm font-bold text-white">
                            working
                          </td>
                          <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                            2078-9-10
                          </td>
                        </tr>
                        <tr className="border-b bg-white">
                          <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                            1
                          </td>
                          <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                            New Company Darta
                          </td>
                          <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                            2078-9-10
                          </td>
                          <td className="mt-1.5 inline-flex whitespace-nowrap rounded-full bg-yellow-500 py-2 px-4 text-sm font-bold text-white">
                            Pending
                          </td>
                          <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                            2078-9-10
                          </td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      {/* second comp table */}
      {/* <div className="mt-10 w-full md:px-10">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="overflow-hidden">
                <div className="bg-primary-blue font-Acme mb-2 flex justify-between gap-10 overflow-x-auto p-3 text-lg">
                  <div className="flex items-center gap-2">
                    <div className="col-span-1 font-bold text-white">1.</div>
                    <div className="font-bold text-white">
                      Company Name: ABC Pvt. Ltd
                    </div>
                  </div>
                  <div className="font-bold text-white">
                    Redg. Date : 2078-12-10
                  </div>
                  <div className="font-bold text-white">Redg. No : 1234567</div>
                  <div className="font-bold text-white">PAN. No : 1234567</div>
                </div>
                <table className="min-w-full text-center">
                  <thead className="font-Bree bg-primary-red border-b font-bold">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        SN.
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Service Name
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Order Date
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        working Status
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-4 text-sm font-medium text-white"
                      >
                        Completed Date
                      </th>
                    </tr>
                  </thead>
                  <tbody className="font-Acme">
                    <tr className="border-b bg-white">
                      <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                        1
                      </td>
                      <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                        New Company Darta
                      </td>
                      <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                        2078-9-10
                      </td>
                      <td className="bg-primary-green mt-1.5 inline-flex whitespace-nowrap rounded-full py-2 px-4 text-sm font-bold text-white">
                        Completed
                      </td>
                      <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                        2078-9-10
                      </td>
                    </tr>
                    <tr className="border-b bg-white">
                      <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                        1
                      </td>
                      <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                        New Company Darta
                      </td>
                      <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                        2078-9-10
                      </td>
                      <td className="bg-primary-blue mt-1.5 inline-flex whitespace-nowrap rounded-full py-2 px-4 text-sm font-bold text-white">
                        working
                      </td>
                      <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                        2078-9-10
                      </td>
                    </tr>
                    <tr className="border-b bg-white">
                      <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                        1
                      </td>
                      <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                        New Company Darta
                      </td>
                      <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                        2078-9-10
                      </td>
                      <td className="mt-1.5 inline-flex whitespace-nowrap rounded-full bg-yellow-500 py-2 px-4 text-sm font-bold text-white">
                        Pending
                      </td>
                      <td className="text-primary-blue whitespace-nowrap px-6 py-4 text-sm font-light">
                        2078-9-10
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default JobDetails;
